<template>
  <div class="text-center">
    <v-btn color="blue" dark @click="sheet = !sheet">Open v-model</v-btn>
    <v-bottom-sheet v-model="isVisible">
      <v-sheet class="text-center" height="200px">
        <v-btn class="mt-6" color="primary" @click="isVisible = !isVisible"
          >OK</v-btn
        >
        <div class="pa-3">
          <div class="pa-3" v-for="n in notifications" v-bind:key="n.id">
            <v-alert :type="n.type">{{ n.message }}</v-alert>
          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
export default {
  name: 'NotificationList',
  props: {
    notifications: {
      type: Array,
      required: true,
      default: function() {
        return {}
      }
    }
  },
  data: () => ({}),
  computed: {
    isVisible: {
      get: function() {
        return this.notifications.length > 0
      },
      set: function(newValue) {
        if (!newValue) {
          this.$store.dispatch('NotificationStore/clearAll', null, {
            root: true
          })
        }
      }
    }
  }
}
</script>

<style scoped></style>
